// extracted by mini-css-extract-plugin
export default {"parentList":"ParentTree_parentList__+PciP"};